import { useEffect, useState, lazy, Suspense } from "react";
import Layout, { LayoutforUser } from "../components/sidebar/layout";
import { Route, Routes } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { LogoLoading } from "../../src/components/common/utlity/utility";
import Notification from "../components/Notification";
import ProtectedRoute from "../components/common/ProtectedRoute";
import GuestTrackings from "./guestTracking/GuestTracking.jsx";

const DashboardStatus = lazy(
  () => import("./dashboard-status/dashboardStatus"),
);
const CreateProfile = lazy(() => import("../components/profile"));
const UpdateProfile = lazy(() => import("../components/newProfile"));
const Subscriber = lazy(() => import("../components/subscriber"));
const Calculator = lazy(() => import("../components/calculator"));
const NotFound = lazy(() => import("./notFound"));
const HelpAndSupportPage = lazy(() => import("../components/help&support"));
const SettingsPage = lazy(() => import("../components/settingPage.jsx"));
const ShortcutsGuide = lazy(() => import("../components/shortcutguied.jsx"));
const RolesPage = lazy(() => import("../components/RolesPage"));
const UserRole = lazy(() => import("../pages/user&Role/user.Role.jsx"));
const DashboardCard = lazy(() => import("../components/newStorePage"));
const MarketingCalendarPage = lazy(
  () => import("./marketing/MarketingCalendarPage"),
);
const NewBussinessForm = lazy(
  () => import("../components/business/NewBussinessForm"),
);
const ForgotPassword = lazy(
  () => import("../components/business/forgotpassword"),
);
const PartitionedPage = lazy(() => import("../components/retailrocketNextCrd"));
const BusinessCardComponent = lazy(
  () => import("../components/businessCardcomponnet"),
);
const RetailRocket = lazy(() => import("../components/retailRocket"));
const RetailRocketPage = lazy(
  () => import("../components/retailRockettemplate"),
);
const CouponDashboard = lazy(
  () => import("../pages/online-store/CouponDashboard"),
);
const Sale = lazy(() => import("./sale/Sale"));
const Buy = lazy(() => import("./buy/Buy"));
const NewSale = lazy(() => import("../components/newSale"));
const NewInventory = lazy(() => import("./inventory/NewInventory"));
const UpdateProduct = lazy(() => import("./inventory/UpdateProduct"));
const UpdateService = lazy(() => import("./inventory/UpdateService"));
const UpdateExpense = lazy(() => import("../pages/expenses/UpdateExpense"));
const UpdateIncome = lazy(() => import("./income/UpdateIncome"));
const UpdateCreditNote = lazy(
  () => import("./credit Debit/UpdateCreditNote.jsx"),
);
const UpdateDebitNote = lazy(
  () => import("./credit Debit/UpdateDebitNote.jsx"),
);
const AddCustomerPage = lazy(() => import("./customer/AddCustomerPage.jsx"));
const EditCustomerPage = lazy(() => import("./customer/EditCustomerPage.jsx"));
const UpdateSupplier = lazy(() => import("./supliers/UpdateSupplier.jsx"));
const AddEmployeeScreen = lazy(
  () => import("./employee/AddEmployeeScreen.jsx"),
);
const NewSaleScreen = lazy(() => import("./sale/NewSaleScreen"));
const NewBuyScreen = lazy(() => import("./buy/NewBuyScreen"));
const InventoryPitara = lazy(
  () => import("../components/invetry/InventoryPitara"),
);
const BulkUpload = lazy(() => import("./bulkUpload/bulkUpload"));
const BulkUploadPage = lazy(() => import("../components/bulkupload.jsx"));
const PurchasePage = lazy(() => import("./inventory/PurchasePage.jsx"));
const SearchPopup = lazy(() => import("../components/addProductpopup"));
const Expenses = lazy(() => import("./expenses/Expense"));
const AddExpenses = lazy(() => import("../components/expenses"));
const Income = lazy(() => import("./income/income"));
const CreditDebitNote = lazy(() => import("./credit Debit/credit_debit"));
const Cashbook = lazy(() => import("./cashbook/cashbook"));
const DeliveryManagement = lazy(
  () => import("../components/deliveryManagement.jsx"),
);
const BarcodeTool = lazy(() => import("../components/barcode/BarcodeTool.jsx"));

const NewCustomer = lazy(() => import("./customer/newCustomer"));
const AddCustomer = lazy(() => import("../components/buddies/customer"));
const BulkUploadCustomers = lazy(
  () => import("./bulkUpload/bulkUploadCustomer"),
);
const ManageSubscription = lazy(() => import("./customer/manageSubscription"));
const CustomerPurchaseHistory = lazy(
  () => import("./customer/customerPurchaseHystory"),
);
const PaymentReminders = lazy(() => import("./customer/paymentReminder.jsx"));
const NewSuplier = lazy(() => import("./supliers/NewSuplier"));
const Employee = lazy(() => import("./employee/Employee"));
const AddEmployee = lazy(() => import("../components/buddies/Addemployees"));
const EcommerceIntegrationForm = lazy(
  () => import("../components/ecommerce.jsx"),
);
// HR & Payroll
const Calenderlook = lazy(() => import("../components/payroll"));
const HolidayInput = lazy(() => import("../components/holidays"));
const WageEmployeeRecordPage = lazy(() => import("../components/wagePayroll"));
const Salaryslip = lazy(() => import("../components/salaryslip"));
const Payrollsalaryslip = lazy(
  () => import("../components/payrollsalaryslip.jsx"),
);

const CreateTicket = lazy(() => import("../components/tickets/createTicket"));
const AllTickets = lazy(() => import("../components/tickets/allTickets.jsx"));
const TasksList = lazy(() => import("./tasks/TasksList"));

const ChatPage = lazy(() => import("../../src/pages/chat/ChatPage.jsx"));
const MessagePage = lazy(() => import("../../src/pages/chat/MessagePage.js"));

const AuthEwaybill = lazy(() => import("../components/Auth-Ewaybill"));
const Usefrom = lazy(() => import("../components/Select-waybill"));
const EwaybillSale = lazy(() => import("../components/ewaybillsell.jsx"));

const ReportPage = lazy(() => import("../components/report/reportPage"));
const InventoryFilterPopup = lazy(
  () => import("../components/report/inventoryReport"),
);
const SalesFilterPopup = lazy(() => import("../components/report/saleReport"));
const PurchaseReportPopup = lazy(
  () => import("../components/report/purchaseReport"),
);
const ExpenseReportPopup = lazy(
  () => import("../components/report/expenseReport"),
);
const ReviewManagementPage = lazy(
  () => import("../pages/online-store/storeSetting/ReviewSection.jsx"),
);
const CustomerReportPopup = lazy(
  () => import("../components/report/customerReport"),
);
const SupplierReportPopup = lazy(
  () => import("../components/report/supplierReport"),
);
const PAndLPopupPage = lazy(() => import("../components/report/pnlReport"));
const PAndLPopupSecond = lazy(
  () => import("../components/report/pNlReportTwo"),
);
const PAndLPopupPagethird = lazy(
  () => import("../components/report/pNlReportthird"),
);
const VerticalTablesPopup = lazy(
  () => import("../components/report/balancesheet"),
);
const SaleDateRangeTable = lazy(
  () => import("../components/report/saleDetailedReport"),
);
const SaleReportByProduct = lazy(
  () => import("../components/report/SaleReportByproduct"),
);
const SaleReportByPercent = lazy(
  () => import("../components/report/saleReportBypercet"),
);
const SaleDetailedView = lazy(
  () => import("../components/report/saleDetailView"),
);
const SaleCustomerDetail = lazy(
  () => import("../components/report/detailCustomerReport"),
);
const CustomerPendingReportPopup = lazy(
  () => import("../components/report/customerPending"),
);
const SuplierPendingReportPopup = lazy(
  () => import("../components/report/suplierPending"),
);
const ReturnDateRangeTable = lazy(
  () => import("../components/report/returnSale"),
);
const AccountingReportsPage = lazy(
  () => import("../components/report/accountingpage"),
);
const CustomReportsPage = lazy(() => import("../components/report/customPage"));
const SalePage = lazy(() => import("../components/report/saleDetailedPage"));
const CustomerReportsPage = lazy(
  () => import("../components/report/customerpage"),
);
const ReturnReportsPage = lazy(() => import("../components/report/returnPage"));
const ReturnReportByPercent = lazy(
  () => import("../components/report/returnReportBypercent"),
);
const ReturnReportByProduct = lazy(
  () => import("../components/report/returnReportByproduct"),
);
const ReturnDetailedView = lazy(
  () => import("../components/report/returnDetailedView"),
);
const SalesProductPercentage = lazy(
  () => import("../components/report/saleProductBypercent"),
);
const PAndLPopupPageWithDateRange = lazy(
  () => import("../components/report/pnlReportBydateRange"),
);
const GstReportsPage = lazy(() => import("../components/report/gstReportPage"));
const GstInvoiceTable = lazy(
  () => import("../components/report/gastROneReport"),
);
const GstThreeBReport = lazy(
  () => import("../components/report/gastRThreeReport"),
);
const ExpenseDateRangeTable = lazy(
  () => import("../components/report/expenseDetailedReport"),
);
const ExpenseReportsPage = lazy(
  () => import("../components/report/expensePage"),
);
const PurchaseReportsPage = lazy(
  () => import("../components/report/purchasePage"),
);
const PurchasedetailedReportPopup = lazy(
  () => import("../components/report/purchaseDetailedReport"),
);
const PurchaseStatusdetailedReportPopup = lazy(
  () => import("../components/report/purchaseDetailsByStatus"),
);
const GstTwoInvoiceTable = lazy(
  () => import("../components/report/gstTwoReport"),
);
const InventoryReportsPage = lazy(
  () => import("../components/report/inventoryPage"),
);
const SalesReport = lazy(
  () => import("../components/report/invoicereport.jsx"),
);
const PurchaseProductList = lazy(
  () => import("../pages/ReceiveProductsPage.jsx"),
);

const SeoSettings = lazy(() => import("./seo/seoSettings.jsx"));
const NewManufacturingScreen = lazy(
  () => import("../pages/manufacturing/NewManufacturingScreen"),
);
// const Gst3BReport = lazy(() => import("../components/report/gstthreeBReport.jsx")); // Commented route, keeping the lazy definition commented
const NewWarehouse = lazy(
  () => import("../components/warehouse/warehouse.jsx"),
);

const LogisticsSettings = lazy(
  () => import("./online-store/LogisticSetting.jsx"),
);

const WarehouseReportsPage = lazy(
  () => import("../components/report/WarehouseReport/WarehousePage.jsx"),
);
// const AddWarehouseitems = lazy(() =>
//   import("../components/warehouse/addWarehouseitem.jsx"))

const Addwarehouseproduct = lazy(
  () => import("../components/warehouse/addWarehouseproductpopup.jsx"),
);
const EmployeeDashboard = lazy(
  () => import("../pages/employee/employeedashborad.jsx"),
);
const LiveTrackingPage = lazy(() => import("./employee/LiveTrackingPage.jsx"));
const Manufacturing = lazy(
  () => import("../pages/manufacturing/manufacturing.jsx"),
);
const SellSourceReport = lazy(
  () => import("../components/report/SellSourceReport"),
);

const RequestBusiness = lazy(() => import("./RequestBusiness"));
const BusinessRequests = lazy(() => import("./BusinessRequests"));
const ApprovedBusinesses = lazy(() => import("./ApprovedBusinesses"));
const RequestedResellers = lazy(() => import("./RequestedResellers"));
const ApprovedResellers = lazy(() => import("./ApprovedResellers"));
const BusinessProducts = lazy(() => import("./BusinessProducts"));
const ResellerCatalog = lazy(() => import("./ResellerCatalog"));
const ResellerStoreSettings = lazy(() => import("./ResellerStoreSettings"));
const ResellerOrders = lazy(() => import("./ResellerOrders"));
const InventoryIntelligenceDashboard = lazy(
  () => import("../pages/InventoryIntelligenceDashboard.jsx"),
);
// --- Dashboard Component ---
const Dashboard = () => {
  const [loading, setLoading] = useState(true);
  // const userRole = localStorage.getItem("role");
  // console.log("userRole", userRole);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 0);

    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <LogoLoading />;
  }

  return (
    <div className='flex'>
      <Layout>
        <Suspense fallback={<LogoLoading />}>
          <Routes>
            {localStorage.getItem("role") === "owner_admin" && (
              <Route path='UserRole' element={<UserRole />} />
            )}

            {/* Warehouse-related routes */}
            {/* <Route path='WarehouseReport' element={<WarehouseReport />} /> */}
            {/* <Route
             path='WarehouseReportsPage'
             element={<WarehouseReportsPag />}
           /> */}
            {/* <Route path='RawMaterialReport' element={<RawMaterialReport />} /> */}
            {/* <Route
             path='RawmatarialReportsPage'
             element={<RawmatarialReportsPage />}
           /> */}
            {/* <Route
             path='Addwarehouseproduct'
             element={<Addwarehouseproduct />}
           />
           <Route path='warehouse' element={<Warehouse />} /> */}

            {/* E-way bill and billing */}
            <Route path='ewaybillsale' element={<EwaybillSale />} />
            <Route path='selectbilling' element={<Usefrom />} />
            <Route path='authewaybill' element={<AuthEwaybill />} />
            <Route path='settingPage' element={<SettingsPage />} />
            <Route path='invoivewise-profit' element={<SalesReport />} />
            {/* <Route path='inventory-management' element={<InventoryIntelligenceDashboard />} /> */}
            <Route path='bulk-upload' element={<BulkUploadPage />} />
            <Route path='warehouse' element={<NewWarehouse />} />
            <Route
              path='inventory-intelligence'
              element={<InventoryIntelligenceDashboard />}
            />
            <Route
              path='Addwarehouseproduct'
              element={<Addwarehouseproduct />}
            />

            <Route
              path='WarehouseReportsPage'
              element={<WarehouseReportsPage />}
            />

            {/* Employees */}
            <Route
              path='buddies/employees/:employeeID'
              element={<Calenderlook />}
            />
            <Route
              path='buddies/employees/:employeeID/wagePayroll'
              element={<WageEmployeeRecordPage />}
            />
            <Route path='seo-settings' element={<SeoSettings />} />
            {/* Reports */}
            <Route path='confirm-order' element={<SearchPopup />} />
            <Route path='shortcut-guide' element={<ShortcutsGuide />} />
            <Route
              path='delivery-management'
              element={<DeliveryManagement />}
            />
            {/* <Route
             path='paymentgateway-varification'
             element={<PaymentCallback />}
           /> */}
            <Route path='new-profile' element={<UpdateProfile />} />
            <Route path='add-more-business' element={<DashboardCard />} />
            <Route path='new-business' element={<NewBussinessForm />} />
            <Route path='forgotpassword' element={<ForgotPassword />} />
            <Route path='rocket-card' element={<PartitionedPage />} />
            <Route path='business-card' element={<BusinessCardComponent />} />
            <Route path='inventory-report' element={<InventoryFilterPopup />} />
            <Route path='sale-report' element={<SalesFilterPopup />} />
            <Route path='purchase-report' element={<PurchaseReportPopup />} />
            <Route path='expense-report' element={<ExpenseReportPopup />} />
            <Route path='customer-report' element={<CustomerReportPopup />} />
            <Route path='suplier-report' element={<SupplierReportPopup />} />
            <Route path='send-reminders' element={<PaymentReminders />} />
            <Route path='basicpnl-report' element={<PAndLPopupPage />} />

            <Route
              path='recievablenpayblepnl-report'
              element={<PAndLPopupSecond />}
            />

            <Route path='detailpnl-report' element={<PAndLPopupPagethird />} />

            {/* More report pages */}
            <Route path='balancesheet' element={<VerticalTablesPopup />} />
            <Route path='sale-table' element={<SaleDateRangeTable />} />
            <Route path='sale-by-product' element={<SaleReportByProduct />} />
            <Route path='sale-by-percent' element={<SaleReportByPercent />} />
            <Route path='sale-detailed-view' element={<SaleDetailedView />} />
            <Route
              path='sale-detailed-customer'
              element={<SaleCustomerDetail />}
            />
            <Route
              path='customer-detailed-customerpending-report'
              element={<CustomerPendingReportPopup />}
            />
            <Route path='employee-management' element={<EmployeeDashboard />} />
            <Route path='live-tracking' element={<LiveTrackingPage />} />
            <Route
              path='live-tracking/:employeeId'
              element={<LiveTrackingPage />}
            />

            <Route
              path='suplier-pending-report'
              element={<SuplierPendingReportPopup />}
            />
            <Route path='return-table' element={<ReturnDateRangeTable />} />
            <Route
              path='accounting-report-page'
              element={<AccountingReportsPage />}
            />
            <Route
              path='purchase/:purchaseId/products'
              element={<PurchaseProductList />}
            />
            <Route path='custom-report-page' element={<CustomReportsPage />} />
            <Route path='sale-report-page' element={<SalePage />} />
            <Route
              path='customer-report-page'
              element={<CustomerReportsPage />}
            />
            <Route path='sell-source-report' element={<SellSourceReport />} />
            <Route
              path='inventory-report-page'
              element={<InventoryReportsPage />}
            />
            <Route path='return-report-page' element={<ReturnReportsPage />} />
            <Route
              path='returnpercent-report-page'
              element={<ReturnReportByPercent />}
            />
            <Route
              path='returnproduct-report-page'
              element={<ReturnReportByProduct />}
            />
            <Route
              path='returndetailed-report-page'
              element={<ReturnDetailedView />}
            />
            <Route path='ecommmerce' element={<EcommerceIntegrationForm />} />
            <Route path='coupons' element={<CouponDashboard />} />

            <Route
              path='saleproduct-report-page'
              element={<SalesProductPercentage />}
            />
            <Route
              path='pnlby-date-report-page'
              element={<PAndLPopupPageWithDateRange />}
            />
            <Route path='gst-report-page' element={<GstReportsPage />} />
            <Route
              path='gst-invoice-report-page'
              element={<GstInvoiceTable />}
            />
            <Route
              path='marketing-calendar'
              element={<MarketingCalendarPage />}
            />
            <Route path='gst-3b-report' element={<GstThreeBReport />} />
            <Route path='gst-3b-report' element={<GstThreeBReport />} />
            <Route
              path='expense-date-report-page'
              element={<ExpenseDateRangeTable />}
            />
            <Route
              path='marketing-calendar'
              element={<MarketingCalendarPage />}
            />
            <Route path='expense-page' element={<ExpenseReportsPage />} />
            <Route path='purchase-page' element={<PurchaseReportsPage />} />
            <Route
              path='purchase-detailed-report-page'
              element={<PurchasedetailedReportPopup />}
            />
            <Route
              path='purchase-status-detailed-report-page'
              element={<PurchaseStatusdetailedReportPopup />}
            />
            <Route
              path='inventory/add-service'
              element={
                <ProtectedRoute routeKey='inventory'>
                  <UpdateService />
                </ProtectedRoute>
              }
            />
            <Route path='gst-r2-report' element={<GstTwoInvoiceTable />} />
            <Route
              path='inventory/add-service'
              element={
                <ProtectedRoute routeKey='inventory'>
                  <UpdateService />
                </ProtectedRoute>
              }
            />

            {/* Miscellaneous */}
            <Route path='holidays' element={<HolidayInput />} />
            <Route path='roles-permission' element={<RolesPage />} />
            <Route index element={<DashboardStatus />} />
            <Route path='profile' element={<CreateProfile />} />
            <Route path='/subscriber' element={<Subscriber />} />
            <Route path='/create-ticket' element={<CreateTicket />} />
            <Route path='/all-tickets' element={<AllTickets />} />
            <Route path='/calculator' element={<Calculator />} />
            {/* Expenses page - requires expense permissions */}
            <Route
              path='bills/dukanExpenses'
              element={
                <ProtectedRoute routeKey='dukanExpenses'>
                  <Expenses />
                </ProtectedRoute>
              }
            />
            {/* Income - requires income permissions */}
            <Route
              path='bills/income'
              element={
                <ProtectedRoute routeKey='income'>
                  <Income />
                </ProtectedRoute>
              }
            />
            <Route
              path='/income/update'
              element={
                <ProtectedRoute routeKey='income'>
                  <UpdateIncome />
                </ProtectedRoute>
              }
            />
            {/* Credit/Debit Notes */}
            <Route
              path='bills/credit-debit'
              element={
                <ProtectedRoute routeKey='credit-debit'>
                  <CreditDebitNote />
                </ProtectedRoute>
              }
            />
            <Route
              path='bills/credit-debit/update'
              element={
                <ProtectedRoute routeKey='credit-debit'>
                  <UpdateCreditNote />
                </ProtectedRoute>
              }
            />
            <Route
              path='bills/credit-debit/debit/update'
              element={
                <ProtectedRoute routeKey='credit-debit'>
                  <UpdateDebitNote />
                </ProtectedRoute>
              }
            />
            {/* Tasks */}
            <Route
              path='/tasks'
              element={
                <ProtectedRoute routeKey='tasks'>
                  <TasksList />
                </ProtectedRoute>
              }
            />
            <Route path='/templates' element={<RetailRocketPage />} />
            {/* Customers */}
            <Route
              path='buddies/customers'
              element={
                <ProtectedRoute routeKey='customers'>
                  <NewCustomer />
                </ProtectedRoute>
              }
            />
            <Route
              path='buddies/customers/add'
              element={
                <ProtectedRoute routeKey='customers'>
                  <AddCustomerPage />
                </ProtectedRoute>
              }
            />

            <Route
              path='buddies/customers/edit/:customerId'
              element={
                <ProtectedRoute routeKey='customers'>
                  <EditCustomerPage />
                </ProtectedRoute>
              }
            />
            <Route
              path='buddies/customers/:customerId'
              element={
                <ProtectedRoute routeKey='customers'>
                  <ManageSubscription />
                </ProtectedRoute>
              }
            />
            <Route
              path='buddies/customers/:customerId/history'
              element={
                <ProtectedRoute routeKey='customers'>
                  <CustomerPurchaseHistory />
                </ProtectedRoute>
              }
            />
            {/* Employees */}
            <Route
              path='buddies/employees'
              element={
                <ProtectedRoute routeKey='employees'>
                  <Employee />
                </ProtectedRoute>
              }
            />
            {/* Suppliers */}
            <Route
              path='buddies/suppliers'
              element={
                <ProtectedRoute routeKey='suppliers'>
                  <NewSuplier />
                </ProtectedRoute>
              }
            />
            <Route
              path='buddies/suppliers/add'
              element={
                <ProtectedRoute routeKey='suppliers'>
                  <UpdateSupplier />
                </ProtectedRoute>
              }
            />

            <Route
              path='buddies/suppliers/update'
              element={
                <ProtectedRoute routeKey='suppliers'>
                  <UpdateSupplier />
                </ProtectedRoute>
              }
            />
            {/* Inventory */}
            <Route
              path='inventory'
              element={
                <ProtectedRoute routeKey='inventory'>
                  <NewInventory />
                </ProtectedRoute>
              }
            />
            <Route
              path='inventory/update-product/:productId'
              element={
                <ProtectedRoute routeKey='inventory'>
                  <UpdateProduct />
                </ProtectedRoute>
              }
            />
            <Route
              path='inventory/update-service/:serviceId'
              element={
                <ProtectedRoute routeKey='inventory'>
                  <UpdateService />
                </ProtectedRoute>
              }
            />
            <Route
              path='inventory/inventory-pitara'
              element={
                <ProtectedRoute routeKey='inventory'>
                  <InventoryPitara />
                </ProtectedRoute>
              }
            />
            {/* Sales */}
            <Route
              path='bills/sale'
              element={
                <ProtectedRoute routeKey='sale'>
                  <Sale />
                </ProtectedRoute>
              }
            />
            <Route path='bills/manufacture' element={<Manufacturing />} />
            <Route
              path='bills/manufacture/add'
              element={
                <ProtectedRoute routeKey='manufacture'>
                  <NewManufacturingScreen />
                </ProtectedRoute>
              }
            />

            <Route
              path='bills/manufacture/update'
              element={
                <ProtectedRoute routeKey='manufacture'>
                  <NewManufacturingScreen />
                </ProtectedRoute>
              }
            />

            {/* Purchase */}
            <Route
              path='bills/buy'
              element={
                <ProtectedRoute routeKey='buy'>
                  <Buy />
                </ProtectedRoute>
              }
            />
            <Route
              path='bills/buy/add'
              element={
                <ProtectedRoute routeKey='buy'>
                  <NewBuyScreen />
                </ProtectedRoute>
              }
            />

            <Route
              path='bills/buy/update'
              element={
                <ProtectedRoute routeKey='buy'>
                  <NewBuyScreen />
                </ProtectedRoute>
              }
            />
            {/* Cashbook */}
            <Route
              path='/cashBook'
              element={
                <ProtectedRoute routeKey='cashBook'>
                  <Cashbook />
                </ProtectedRoute>
              }
            />
            <Route path='/reportPage' element={<ReportPage />} />
            <Route path='/retailRocket' element={<RetailRocket />} />
            <Route path='/chat' element={<ChatPage />}>
              <Route path='message/:userId' element={<MessagePage />} />
            </Route>
            <Route path='/barcode' element={<BarcodeTool />} />
            <Route path='inventory/bulkupload' element={<BulkUpload />} />
            <Route
              path='buddies/customers/bulkupload'
              element={<BulkUploadCustomers />}
            />
            {/* Expenses */}
            <Route
              path='/expenses'
              element={
                <ProtectedRoute routeKey='dukanExpenses'>
                  <AddExpenses />
                </ProtectedRoute>
              }
            />
            <Route
              path='/expenses/update'
              element={
                <ProtectedRoute routeKey='dukanExpenses'>
                  <UpdateExpense />
                </ProtectedRoute>
              }
            />
            {/* Add Customer */}
            <Route
              path='/customer'
              element={
                <ProtectedRoute routeKey='customers'>
                  <AddCustomer />
                </ProtectedRoute>
              }
            />
            {/* Add Employee */}
            <Route
              path='/employee'
              element={
                <ProtectedRoute routeKey='employees'>
                  <AddEmployee />
                </ProtectedRoute>
              }
            />
            <Route
              path='buddies/employees/add'
              element={
                <ProtectedRoute routeKey='employees'>
                  <AddEmployeeScreen />
                </ProtectedRoute>
              }
            />

            <Route
              path='buddies/employees/update-employee'
              element={
                <ProtectedRoute routeKey='employees'>
                  <AddEmployeeScreen />
                </ProtectedRoute>
              }
            />
            <Route path='/newSale' element={<NewSale />} />
            <Route
              path='bills/sale/add'
              element={
                <ProtectedRoute routeKey='sale'>
                  <NewSaleScreen />
                </ProtectedRoute>
              }
            />

            <Route
              path='bills/sale/update'
              element={
                <ProtectedRoute routeKey='sale'>
                  <NewSaleScreen />
                </ProtectedRoute>
              }
            />
            <Route path='/help-support' element={<HelpAndSupportPage />} />
            <Route
              path='buddies/employees/:employeeID/wagePayroll/salaryslip'
              element={<Salaryslip />}
            />
            <Route
              path='buddies/employees/:employeeID/Payroll/salaryslip'
              element={<Payrollsalaryslip />}
            />
            <Route path='/allReview' element={<ReviewManagementPage />} />
            <Route path='low-stock-order' element={<PurchasePage />} />
            <Route path='/logistics/settings' element={<LogisticsSettings />} />
            <Route path='/guest-tracking' element={<GuestTrackings />} />

            <Route path='request-business' element={<RequestBusiness />} />
            <Route path='business-requests' element={<BusinessRequests />} />
            <Route
              path='approved-businesses'
              element={<ApprovedBusinesses />}
            />
            <Route
              path='requested-resellers'
              element={<RequestedResellers />}
            />
            <Route path='approved-resellers' element={<ApprovedResellers />} />
            <Route
              path='business-products/:businessUuid'
              element={<BusinessProducts />}
            />
            <Route path='my-catalog' element={<ResellerCatalog />} />
            <Route path='store-settings' element={<ResellerStoreSettings />} />
            <Route path='reseller-orders' element={<ResellerOrders />} />

            {/* Fallback Route for 404 */}
            <Route path='*' element={<NotFound />} />
          </Routes>
        </Suspense>
      </Layout>

      {/* Notifications */}
      <Notification />
    </div>
  );
};

// --- DashboardForUser Component (Updated with Suspense for consistency) ---
export const DashboardForUser = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <LogoLoading />;
  }
  return (
    <div>
      <div className='flex'>
        <LayoutforUser />
        <Suspense fallback={<div>Loading User Pages...</div>}>
          {" "}
          {/* Added Suspense here */}
          <Routes>
            {/* Define routes here */}
            <Route index element={<div>Dashboard page will render here</div>} />
            <Route path='profile' element={<div>Profile page</div>} />
            <Route path='new-bussiness' element={<div>New bussiness</div>} />
            <Route path='subscription' element={<div>Subscription page</div>} />
            <Route path='logout' element={<div>logout page</div>} />
          </Routes>
        </Suspense>
        <Notification /> {/* Assuming this is your notification component */}
      </div>
    </div>
  );
};
export default Dashboard;
